var validatorRequired = function validatorRequired(target, formData) {
    if (target.value === "") {
        return { "success": false, "message": "Required" };
    }

    return { "success": true };
};

module.exports = {
    validatorRequired: validatorRequired
};